import { Link } from "react-router-dom";
import { Clapperboard } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { Reveal } from "@/components/site/Reveal";
import { Squiggle, Bubble, Star } from "@/components/site/Doodles";
import { WhatsAppIcon, FacebookIcon, InstagramIcon } from "@/components/site/Icons";
import { SITE, waLink } from "@/lib/site";

const cards = () => [
  { href: waLink("أهلاً خرابيش موشن"), Icon: WhatsAppIcon, title: "واتساب", value: SITE.whatsapp, color: "#25D366", id: "whatsapp", big: true },
  { href: SITE.facebook, Icon: FacebookIcon, title: "فيسبوك", value: "facebook.com/Kharabeeshmotion", color: "#1877F2", id: "facebook" },
  { href: SITE.instagram, Icon: InstagramIcon, title: "إنستجرام", value: "@kharabeeshstudio", color: "#9B3BF0", id: "instagram" },
];

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <Seo title="كلمنا" description="تواصل مع خرابيش موشن على واتساب أو فيسبوك أو إنستجرام، أو ابعت طلب إعلانك من الموقع." />
      <section className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 md:py-24 lg:px-8">
        <Bubble className="km-float absolute left-10 top-20 h-20 w-20" />
        <Star className="km-float absolute bottom-10 left-1/2 h-8 w-8 [animation-delay:1s]" color="#9B3BF0" />
        <Reveal>
          <p className="font-head mb-3 text-[var(--km-cyan)]">كلمنا</p>
          <h1 className="font-display max-w-3xl text-5xl leading-tight text-white sm:text-6xl lg:text-7xl">
            عندك فكرة؟ <span className="relative inline-block text-[var(--km-pink)]">قولها<Squiggle className="absolute -bottom-3 right-0 h-5 w-full" color="#E9D8FF" /></span> وإحنا نحركها
          </h1>
          <p className="mt-8 max-w-xl text-lg text-purple-200/90">أسرع طريقة توصلنا بيها هي الواتساب. وتقدر كمان تبعتلنا على السوشيال ميديا أو تملا فورم الإعلان.</p>
        </Reveal>

        <div className="mt-14 grid gap-5 md:grid-cols-2">
          {cards().map(({ href, Icon, title, value, color, id, big }, i) => (
            <Reveal key={id} delay={i * 0.08} className={big ? "md:row-span-2" : ""}>
              <a href={href} target="_blank" rel="noopener noreferrer" data-testid={`contact-${id}-card`}
                className="group relative flex h-full flex-col justify-between gap-8 overflow-hidden rounded-[2rem] border border-purple-500/25 bg-[var(--km-card)] p-8 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-white/50">
                <span className="grid h-16 w-16 place-items-center rounded-2xl text-white transition-transform duration-300 group-hover:-rotate-12" style={{ background: color }}>
                  <Icon className="h-8 w-8" />
                </span>
                <span>
                  <span className="font-head block text-2xl font-bold text-white">{title}</span>
                  <span className={`font-head mt-1 block break-all font-semibold text-[var(--km-lilac)] ${big ? "text-3xl sm:text-4xl" : "text-lg"}`} dir="ltr" style={{ textAlign: "right" }}>{value}</span>
                </span>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <Link to="/create-ad" data-testid="contact-form-card"
            className="group mt-5 flex flex-col items-start gap-4 rounded-[2rem] bg-[var(--km-purple)] p-8 transition-transform duration-300 hover:-rotate-1 sm:flex-row sm:items-center sm:justify-between">
            <span className="flex items-center gap-4">
              <Clapperboard className="h-10 w-10 text-white" />
              <span>
                <span className="font-display block text-3xl text-white">فورم اعمل إعلانك</span>
                <span className="text-white/80">ابعت اللوجو والبريف وأولويات الإعلان مرة واحدة</span>
              </span>
            </span>
            <span className="font-head rounded-full bg-white px-6 py-3 font-bold text-[var(--km-purple)]">املا الفورم</span>
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
